"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const encoding_1 = require("@iov/encoding");
/** Use this to decode non-optional strings */
function decodeString(input) {
    // weave encodes empty strings as null
    return input || "";
}
exports.decodeString = decodeString;
function ensure(maybe, msg) {
    if (maybe === null || maybe === undefined) {
        throw new Error("missing " + (msg || "field"));
    }
    return maybe;
}
exports.ensure = ensure;
/**
 * Decodes a protobuf int field (int32/uint32/int64/uint64) into a JavaScript
 * number.
 */
function asIntegerNumber(maybeLong) {
    if (!maybeLong) {
        return 0;
    }
    else if (typeof maybeLong === "number") {
        if (!Number.isInteger(maybeLong)) {
            throw new Error("Number is not an integer.");
        }
        return maybeLong;
    }
    else {
        return maybeLong.toInt();
    }
}
exports.asIntegerNumber = asIntegerNumber;
function decodeNumericId(id) {
    return encoding_1.Uint64.fromBytesBigEndian(id).toNumber();
}
exports.decodeNumericId = decodeNumericId;
//# sourceMappingURL=decodinghelpers.js.map